import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import '../../App.css';
import {dataRegister} from "../../services/dataRegister";
import {cartRegister} from "../../services/cartRegister";
import {langRegister} from "../../services/langRegister";
import Slider, {Range} from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import * as Icon from "react-feather";
import {marketRegister} from "../../services/marketRegister";
import Basket from "../../components/basket/component";
import SignupBudgetBasic from "../../components/signup-budget-basic/component";
import SignupBudgetAdvanced from "../../components/signup-budget-advanced/component";
import ReactGA from 'react-ga';
import {salesChannelRegister} from "../../services/salesChannelRegister";

const Handle = Slider.Handle;

class SignupBudget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vat: 0,
            currency: null,
            market: null,
            budget: null,
            channels: null,
            duration: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            tab: "basic"
        };
        this._updateBudget = this._updateBudget.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();

        //GOOGLE ANALYTICS
        if(window.location.href.indexOf("devadbop.com") === -1){
            ReactGA.pageview('/signup-budget');
        }
    }

    _updateData() {
        let stored_data = cartRegister.get();
        if (stored_data.admin_image) {
            if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                this.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
            }
        }
        if (stored_data.industry && stored_data.regions && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.budget && stored_data.plan) {
            this.setState({
                market: salesChannelRegister.get("market"),
                currency: salesChannelRegister.get("currency"),
                vat: salesChannelRegister.get("vat"),
                regions: stored_data.regions ? stored_data.regions : [],
                channels: stored_data.channels,
                budget: stored_data.budget,
                duration: stored_data.duration ? stored_data.duration : 30,
                plan: stored_data.plan,
                service_fee_percentage: stored_data.servicefee_percentage,
                service_fee_fixed: stored_data.servicefee_fixed
            })
        } else {
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
        }
    }

    _updateBudget(value){
        if(value){
            this.setState({budget: value}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _renderImpressionsTotal() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + (this.state.budget[key].budget / this.state.budget[key].cpi)
                }
            }
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderLeadsTotal() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.budget) {
                if (this.state.channels[key].selected) {
                    clicks = clicks + (this.state.budget[key].budget / this.state.budget[key].cpc)
                }
            }
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if(this.state.service_fee_fixed){
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if(this.state.service_fee_percentage){
                budget = budget + this._renderPercentageFee();
            }

            /*
            //IF VAT
            if(this.state.vat){
                budget = budget + this._renderVat();
            }
            */

            return budget;
        }
    }

    _renderPercentageFee(){
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            return budget * (this.state.service_fee_percentage / 100);
        }
    }

    _renderVat(){
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if(this.state.service_fee_fixed){
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if(this.state.service_fee_fixed){
                budget = budget + this._renderPercentageFee();
            }

            return budget * (this.state.vat / 100);
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-budget", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupTwo props={this.props} step={3}/>
                {
                    this.state.channels && this.state.budget && this.state.plan && this.state.currency && this.state.regions &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            {this._renderText("item_27")}&nbsp;<span className={Styles.titleBold}>{this._renderNumbers(this._renderImpressionsTotal())}&nbsp;</span>{this._renderText("item_28")}&nbsp;<span className={Styles.titleBold}>{this._renderNumbers(this._renderLeadsTotal())}</span>&nbsp;{this._renderText("item_29")}
                        </div>
                        <div className={Styles.containerInner}>
                            <div className={Styles.left}>

                                <div className={Styles.tabsContainer}>
                                    <div onClick={() => this.setState({tab: "basic"})} className={
                                        cx(Styles.tabsContainerItem,
                                            {
                                                [Styles.tabsContainerItemActive]: this.state.tab === "basic",
                                            })
                                    }>
                                        {this._renderText("item_44")}
                                    </div>
                                    <div onClick={() => this.setState({tab: "advanced"})} className={
                                        cx(Styles.tabsContainerItem,
                                            {
                                                [Styles.tabsContainerItemActive]: this.state.tab === "advanced",
                                            })
                                    }>
                                        {this._renderText("item_45")}
                                    </div>
                                </div>
                                {
                                    this.state.tab === "basic" &&
                                    <SignupBudgetBasic updateBudget={this._updateBudget} budget={this.state.budget} channels={this.state.channels} currency={this.state.currency}/>

                                }
                                {
                                    this.state.tab === "advanced" &&
                                    <SignupBudgetAdvanced updateBudget={this._updateBudget} budget={this.state.budget} channels={this.state.channels} currency={this.state.currency}/>
                                }
                                <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/signup/checkout")}
                                     className={
                                         cx(Styles.button,
                                             {
                                                 [Styles.buttonActive]: true
                                             })
                                     }>
                                    {this._renderText("item_14")}
                                    <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}&nbsp;{this.state.currency.toLowerCase()}
                                    </span>
                                </div>
                                <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/signup/filter")}
                                     className={Styles.backButton}>
                                    {this._renderText("item_23")}
                                </div>
                            </div>
                            <div className={Styles.right}>

                                <div className={Styles.contentContainerRightInner}>
                                    <Basket updateBudget={this._updateBudget} props={this.props} regions={this.state.regions} nextView={"/signup/checkout"} serviceFeeFixed={this.state.service_fee_fixed} serviceFeePercentage={this.state.service_fee_percentage}  budget={this.state.budget} channels={this.state.channels} currency={this.state.currency} plan={this.state.plan} vat={this.state.vat} duration={this.state.duration}/>
                                    <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/signup/checkout")} className={
                                        cx(Styles.contentContainerRightButton,
                                            {
                                                [Styles.buttonActive]: true
                                            })
                                    }>
                                        {this._renderText("item_14")}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default SignupBudget;


// WEBPACK FOOTER //
// ./src/pages/signup-budget/component.js